module.exports = __webpack_public_path__ + "84278d07095f11f88a156b31861aa3b6.otf";